/**
 * Plain text of a task description stored as HTML (the team's rich-text editor). Block ends become line breaks and
 * entities are decoded; nothing is rendered as HTML (DOMParser documents never run scripts).
 */
export const htmlToText = (html: string | null | undefined): string => {
  if (!html) return '';
  const withBreaks = html.replace(/<br\s*\/?>/gi, '\n').replace(/<\/(p|div|li|h[1-6]|blockquote|pre)>/gi, '\n');
  const body = new DOMParser().parseFromString(withBreaks, 'text/html').body;
  body.querySelectorAll('script, style').forEach(node => node.remove());
  const text = body.textContent ?? '';
  return text.replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
};
